import { Injectable } from '@angular/core';

import { AuthService } from '@core/services';

@Injectable()
export class PlayerGuard {
  constructor(private authService: AuthService) {}

  async canActivate() {
    return this.authService.user.isPlayer;
  }
}
